import CertificateUpload from './Upload.vue';
export default CertificateUpload;
